import React, { useState } from 'react';
import EvaluationFormHeader from './components/EvaluationFormHeader/EvaluationFormHeader';
import EvaluationSectionForm from './components/EvaluationSectionForm/EvaluationSectionForm';
import './EvaluationFormPage.scss';

const EvaluationFormPage = () => {
  const [createdFormId, setCreatedFormId] = useState(null);

  return (
    <div className="p-6">
      <EvaluationFormHeader onFormCreated={setCreatedFormId} />
      {createdFormId && <EvaluationSectionForm formId={createdFormId} />}
    </div>
  );
};

export default EvaluationFormPage;
